import { ButtonElement } from "appworks/graphics/elements/button-element";
import { GenericControlFactory } from "appworks/ui/factories/generic-control-factory";
import { MatrixSkipAreaControlFactory } from "appworks/ui/factories/standard/matrix-skip-area-control-factory";
import { EpicExternalRulesButtonControl } from "epic/controls/epic-external-rules-button-control";
import { EpicMobileRulesControlFactory } from "epic/controls/factories/epic-mobile-rules-control-factory";
import { EpicPortraitTotalStakeStepperControlFactory } from "epic/controls/factories/epic-portrait-total-stake-stepper-control-factory";
import { EpicHistoryButtonControl } from "../epic-history-button-control";
import { EpicSpinIDControlFactory } from "./epic-spin-id-control-factory";

export function GetEpicStandardFactories() {
    return [
        new EpicPortraitTotalStakeStepperControlFactory(),
        new MatrixSkipAreaControlFactory(),
        new EpicSpinIDControlFactory(),
        new EpicMobileRulesControlFactory(),
        new GenericControlFactory("history", ButtonElement, EpicHistoryButtonControl),
        new GenericControlFactory("external_rules", ButtonElement, EpicExternalRulesButtonControl),
    ];
}
